import { RichText } from "prismic-reactjs"
import React from "react"

const PricingSection = ({ pricing, link }) => {
  return (
    <section className="py-7 text-center border-bottom">
      <div className="container">
        <h2 className="mb-5 section-title text-center">{pricing.title}</h2>
        <div className="row">
          {pricing.plans?.map((p, i) => (
            <div key={i} className="col-md">
              <div className="card shadow border-0 mb-4 mb-md-0">
                <div className="card-header bg-dark">
                  <h4 className="text-light">{p.title}</h4>
                  <small className="text-muted">{p.subtitle_pricing}</small>
                </div>
                <div className="card-body">
                  <h5 className="card-title text-primary font-weight-light">
                    {p.price}
                  </h5>
                  <ul className="list-unstyled my-3">
                    {RichText.render(p.benefits_pricing.raw)}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-5">
          <a className="cta" href={link}>
            {pricing.button}
          </a>
        </div>
      </div>
    </section>
  )
}

export default PricingSection
